<!-- RAI Header: Top bar with search + left sidebar navigation -->
<div class="rai-header-wrapper">
  <!-- Top Bar -->
  <header class="rai-top-bar">
    <div class="rai-top-bar-inner">
      <!-- Left section: hamburger + brand + page title -->
      <div class="rai-top-left">
        <button class="rai-hamburger" *ngIf="!isDashboard" (click)="isMobileMode ? toggleSidebar() : toggleSidebarCollapse()" aria-label="Toggle navigation menu">
          <i class="fa fa-bars"></i>
        </button>
        <img class="rai-brand-logo" [src]="cdnEndPoint + '/medpointapps/img/app-logos/RASPberryAI_color.svg'" alt="RASPberry AI" />
        <span class="rai-page-title" *ngIf="!isMobileMode" [innerHTML]="portalDisplayName | async"></span>
      </div>

      <!-- Right section: AI panel, dark mode, admin tools, notifications, help, user -->
      <ul id="desktopsearchwrap" class="rai-top-right d-flex align-items-center flex-shrink-0 list-unstyled p-0 ms-auto">
        <!--User display name-->
        <li class="rai-user-display-name d-flex flex-column align-items-end justify-content-center position-relative w-auto h-auto flex-shrink-0 pe-2" *ngIf="userDisplayName">
          <span class="rai-user-name-text">{{ userDisplayName | decodeHtml }}</span>
          <span class="rai-user-role-text" *ngIf="userRole">{{ userRole | decodeHtml }}</span>
        </li>
        <li class="separator" *ngIf="userDisplayName && !isMobileMode"></li>

        <!--AI Assistant toggle-->
          <li *ngIf="isAIEnabled && !isRaspberryAIFeatureSelected" class="position-relative w-auto h-auto flex-shrink-0">
          <button class="rai-ai-toggle-btn" (click)="toggleAiPanel()" [class.active]="isAiPanelOpen" title="RASPberry AI">           
            <i class="fa fa-commenting-o raspberry-ai-icon"></i>
          </button>
        </li>

        <!--Admin tools-->
        <li *ngIf="(isPortalToolVisibled | async) && !isMobileMode" id="topmenu-admin" class="topmenu-admin top-menu-icon" ngbDropdown #toolDrop="ngbDropdown" (mouseover)='over(toolDrop)' (mouseout)='out(toolDrop)' display="dynamic" placement="bottom-end">
          <a href="javascript:void(0)" ngbDropdownAnchor id="drpMenuTool"></a>
          <div id="menu-container-topmenu-admin" class="menu-control-container topmenu-admin-cls rounded-0" (click)="toolDrop.toggle()" ngbDropdownMenu aria-labelledby="drpMenuTool">
            <div *ngFor="let item of toolsMenu | async">
              <div class="groupheader li-menu-items" onclick="return false;" *ngIf="item.ShowGroupHeader">{{item.DisplayName}}</div>
              <div id="menu-analytics" style="display:flex;" class="li-menu-items" *ngFor="let subitem of item.AdminToolSubMenu | orderBy : 'Ordinal'" routerLinkActive="dropdown-active">
                <a [href]="((subitem.SubMenuDisplayName.toLowerCase() === 'portal admin') ? AppUrl : AdminAppUrl) + subitem.SubMenuUrl" *ngIf="subitem.IsExternalLink"><span class="menu-{{subitem.SubMenuName}} top-menu-icon"></span> {{subitem.SubMenuDisplayName}}</a>
                <a routerLink="{{subitem.SubMenuUrl}}" *ngIf="!subitem.IsExternalLink"><span class="menu-{{subitem.SubMenuName}} top-menu-icon" medpt-log-action="View" [attr.medpt-log-message]="'Navigate to ' + subitem.SubMenuName + ' page'"></span> {{subitem.SubMenuDisplayName}}</a>
              </div>
            </div>
          </div>
        </li>

        <!--Notification-->
        <medpt-user-notification></medpt-user-notification>        

        <!--Help-->
        <li *ngIf="!isMobileMode" id="topmenu-help" class="topmenu-help top-menu-icon" ngbDropdown #helpDrop="ngbDropdown" (mouseover)='over(helpDrop)' (mouseout)='out(helpDrop)' display="dynamic" placement="bottom-end">
          <a href="javascript:void(0)" ngbDropdownAnchor id="drpMenuHelp"></a>
          <div id="menu-container-topmenu-help" class="menu-control-container topmenu-help-cls rounded-0" (click)="helpDrop.toggle()" ngbDropdownMenu aria-labelledby="drpMenuHelp">
            <div id="menu-help" style="display:flex;" class="li-menu-items" routerLinkActive="dropdown-active" [routerLinkActiveOptions]="{exact: true}">
              <a href="javascript:void(0);" [routerLink]="['./Help']"><span class="menu-help top-menu-icon"></span> Help</a>
            </div>
            <div id="menu-contact" style="display:flex;" class="li-menu-items" routerLinkActive="dropdown-active" [routerLinkActiveOptions]="{exact: true}">
              <a href="javascript:void(0);" [routerLink]="['./Contact']"><span class="menu-contact top-menu-icon"></span> Contact</a>
            </div>
          </div>
        </li>

        <!--User-->
        <li *ngIf="!isMobileMode" id="topmenu-user" class="topmenu-useraccount top-menu-icon" ngbDropdown #userDrop="ngbDropdown" (mouseover)='over(userDrop)' (mouseout)='out(userDrop)' display="dynamic" placement="bottom-end">
          <a href="javascript:void(0)" ngbDropdownAnchor id="drpMenuUser"></a>
          <div id="menu-container-topmenu-user" class="menu-control-container topmenu-user-cls rounded-0" (click)="userDrop.toggle()" ngbDropdownMenu aria-labelledby="drpMenuUser">
            <div id="menu-changepassword" style="display:flex;" class="li-menu-items" routerLinkActive="dropdown-active">
              <a href="{{myAppUrl}}/Account/Manage/ChangePassword"><span class="menu-changepassword top-menu-icon"></span> Change password</a>
            </div>
            <div id="menu-myaccount" style="display:flex;" class="li-menu-items" routerLinkActive="dropdown-active">
              <a routerLink="/Account/MyAccount" medpt-log-action="View" [attr.medpt-log-message]="'Navigate to My account page'"><span class="menu-myaccount top-menu-icon"></span> My account</a>
            </div>
            <div id="menu-manage-passkey" style="display:flex;" class="li-menu-items" routerLinkActive="dropdown-active">
              <a href="{{secureAppUrl}}/Account/Manage/Passkeys"><span class="menu-manage-passkey top-menu-icon"></span> Manage Passkeys</a>
            </div>
            <div id="menu-logout" style="display:flex;" class="li-menu-items" routerLinkActive="dropdown-active">
              <a href="javascript:void(0);" (click)="logout()"><span class="menu-logout top-menu-icon"></span> Logout</a>
            </div>
          </div>
        </li>

        <!--My apps-->
        <li class="separator"></li>
        <li id="app-menu" class="position-relative appmenu-header d-flex align-items-center justify-content-center" medpt-apps-menu></li>
        <li class="separator"></li>
      </ul>     
    </div>
  </header>

  <!-- Main layout: Sidebar + Content -->
  <div class="rai-shell">
    <!-- Desktop sidebar -->
    <aside class="rai-sidebar" *ngIf="!isMobileMode && !isDashboard"
           [ngClass]="{'rai-sidebar--collapsed': isSidebarCollapsed}">
      <!-- Study selector (desktop sidebar) -->
      <div class="rai-sidebar-study-selector" *ngIf="portalList.length > 1 && !isSidebarCollapsed">
        <button class="rai-sidebar-study-btn" (click)="portallistopened=!portallistopened">
          <i class="fa fa-flask"></i>
          <span>{{ (portalDisplayName | async) || 'Trials' }}</span>
          <i class="fa fa-chevron-down rai-chevron" [ngClass]="{'rai-chevron--open': portallistopened}"></i>
        </button>
        <div class="rai-sidebar-study-list" *ngIf="portallistopened">
          <div class="rai-sidebar-study-link">
            <a class="rai-sidebar-study-item rai-sidebar-study-item--dashboard"
               routerLink="/dashboard"
               (click)="portallistopened=false; searchText=''; applyFilter(null);">
              My Trials
            </a>
          </div>
          <div class="rai-sidebar-study-search">
            <input type="text" [(ngModel)]="searchText" (keyup)="applyFilter($event)" placeholder="Search trials..." autocomplete="off" />
          </div>
          <div class="rai-sidebar-study-items">
            <a class="rai-sidebar-study-item" *ngFor="let studyPortal of filteredPortalList"
               href="/Go/{{studyPortal.SponsorName}}/{{studyPortal.PortalName}}/{{raiHomeRoute}}"
               (click)="portallistopened=false; searchText=''; applyFilter(null);">
              {{studyPortal.DisplayName}}
            </a>
          </div>
        </div>
      </div>
      <div class="rai-sidebar-study-selector rai-sidebar-study-selector--collapsed" *ngIf="portalList.length > 1 && isSidebarCollapsed" title="Trials">
        <button class="rai-sidebar-study-btn" (click)="portallistopened=!portallistopened">
          <i class="fa fa-flask"></i>
        </button>
        <div class="rai-sidebar-study-flyout" *ngIf="portallistopened">
          <div class="rai-sidebar-study-link">
            <a class="rai-sidebar-study-item rai-sidebar-study-item--dashboard"
               routerLink="/dashboard"
               (click)="portallistopened=false; searchText=''; applyFilter(null);">
              My Trials
            </a>
          </div>
          <div class="rai-sidebar-study-search">
            <input type="text" [(ngModel)]="searchText" (keyup)="applyFilter($event)" placeholder="Search trials..." autocomplete="off" />
          </div>
          <div class="rai-sidebar-study-items">
            <a class="rai-sidebar-study-item" *ngFor="let studyPortal of filteredPortalList"
               href="/Go/{{studyPortal.SponsorName}}/{{studyPortal.PortalName}}/{{raiHomeRoute}}"
               (click)="portallistopened=false; searchText=''; applyFilter(null);">
              {{studyPortal.DisplayName}}
            </a>
          </div>
        </div>
      </div>

      <nav class="rai-sidebar-nav" *ngIf="!isDashboard && raiNavItems.length > 0">
        <ul class="rai-nav-list">
          <li class="rai-nav-item">
            <a class="rai-nav-link"
               [routerLink]="'/Go/' + sponsorName + '/' + portalName + '/' + raiHomeRoute"
               [class.active]="isRouteActive(getRaiRoute(raiHomeRoute))"
               [attr.title]="isSidebarCollapsed ? 'Home' : null">
              <span class="rai-nav-icon"><i class="fa fa-home"></i></span>
              <span class="rai-nav-text" *ngIf="!isSidebarCollapsed">Home</span>
            </a>
          </li>
          <ng-container *ngFor="let item of raiNavItems">
            <li class="rai-nav-item">
              <!-- Parent-only item (e.g. Tools): clicking expands sub-items, no routing -->
              <a class="rai-nav-link"
                 *ngIf="item.expandOnly"
                 href="javascript:void(0);"
                 (click)="toggleSubmenu(item)"
                 [attr.title]="isSidebarCollapsed ? item.label : null">
                <span class="rai-nav-icon"><i class="fa" [ngClass]="item.icon"></i></span>
                <span class="rai-nav-text" *ngIf="!isSidebarCollapsed">{{ item.label }}</span>
                <button type="button" class="rai-nav-chevron"
                        *ngIf="item.children.length > 0 && !isSidebarCollapsed"
                        (click)="$event.preventDefault(); $event.stopPropagation(); toggleSubmenu(item)"
                        [attr.aria-label]="item.expanded ? 'Collapse ' + item.label : 'Expand ' + item.label">
                  <i class="fa" [ngClass]="item.expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                </button>
              </a>

              <!-- Regular item routing to its component -->
              <a class="rai-nav-link"
                 *ngIf="!item.expandOnly"
                 [routerLink]="getRaiRoute(item.route)"
                 [class.active]="isRouteActive(getRaiRoute(item.route))"
                 [attr.title]="isSidebarCollapsed ? item.label : null"
                 medpt-log-action="View"
                 [attr.medpt-log-message]="'Navigate to ' + item.label + ' page'">
                <span class="rai-nav-icon"><i class="fa" [ngClass]="item.icon"></i></span>
                <span class="rai-nav-text" *ngIf="!isSidebarCollapsed">{{ item.label }}</span>
                <button type="button" class="rai-nav-chevron"
                        *ngIf="item.children.length > 0 && !isSidebarCollapsed"
                        (click)="$event.preventDefault(); $event.stopPropagation(); toggleSubmenu(item)"
                        [attr.aria-label]="item.expanded ? 'Collapse ' + item.label : 'Expand ' + item.label">
                  <i class="fa" [ngClass]="item.expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                </button>
              </a>

              <ul class="rai-subnav" *ngIf="item.children.length > 0 && item.expanded && !isSidebarCollapsed">
                <li *ngFor="let child of item.children">
                  <a class="rai-subnav-link"
                     [routerLink]="getRaiRoute(child.route)"
                     [class.active]="isRouteActive(getRaiRoute(child.route))"
                     medpt-log-action="View"
                     [attr.medpt-log-message]="'Navigate to ' + child.label + ' page'">
                    {{ child.label }}
                  </a>
                </li>
              </ul>
            </li>
          </ng-container>
        </ul>

      </nav>

      <!-- Feedback button -->
      <button class="rai-sidebar-feedback" type="button" (click)="openFeedback()" [attr.title]="isSidebarCollapsed ? 'Feedback' : null">
        <i class="fa fa-comment-o"></i>
        <span *ngIf="!isSidebarCollapsed">Feedback</span>
      </button>

      <!-- Collapse toggle -->
      <button class="rai-sidebar-toggle" type="button" (click)="toggleSidebarCollapse()"
              [attr.aria-label]="isSidebarCollapsed ? 'Expand side menu' : 'Collapse side menu'">
        <i class="fa" [ngClass]="isSidebarCollapsed ? 'fa-angle-right' : 'fa-angle-left'"></i>
        <span *ngIf="!isSidebarCollapsed">Collapse</span>
      </button>
    </aside>

    <!-- Mobile sidebar overlay -->
    <div class="rai-sidebar-backdrop" *ngIf="isMobileMode && isSidebarOpen && !isDashboard" (click)="closeSidebar()"></div>
    <aside class="rai-sidebar rai-sidebar--mobile" *ngIf="isMobileMode && !isDashboard" [ngClass]="{'rai-sidebar--open': isSidebarOpen}">
      <div class="rai-sidebar-mobile-header">
        <span class="rai-sidebar-mobile-title">Navigation</span>
        <button class="rai-sidebar-close" (click)="closeSidebar()" aria-label="Close navigation">
          <i class="fa fa-times"></i>
        </button>
      </div>

      <!-- Study selector (mobile) -->
      <div class="rai-mobile-study-selector" *ngIf="portalList.length > 1">
        <button class="rai-mobile-study-btn" (click)="portallistopened=!portallistopened">
          <i class="fa fa-flask"></i> {{ (portalDisplayName | async) || 'Trials' }}
          <i class="fa fa-chevron-down rai-chevron" [ngClass]="{'rai-chevron--open': portallistopened}"></i>
        </button>
        <div class="rai-mobile-study-list" *ngIf="portallistopened">
          <a class="rai-mobile-study-item rai-mobile-study-item--dashboard"
             routerLink="/dashboard"
             (click)="closeSidebar(); searchText=''; applyFilter(null);">
            My Trials
          </a>
          <div class="rai-mobile-study-search">
            <input type="text" [(ngModel)]="searchText" (keyup)="applyFilter($event)" placeholder="Search trials..." autocomplete="off" />
          </div>
          <a class="rai-mobile-study-item" *ngFor="let studyPortal of filteredPortalList"
             href="/Go/{{studyPortal.SponsorName}}/{{studyPortal.PortalName}}/{{raiHomeRoute}}"
             (click)="closeSidebar(); searchText=''; applyFilter(null);">
            {{studyPortal.DisplayName}}
          </a>
        </div>
      </div>

      <nav class="rai-sidebar-nav">
        <ul class="rai-nav-list" *ngIf="!isDashboard && raiNavItems.length > 0">
          <li class="rai-nav-item">
            <a class="rai-nav-link"
               [routerLink]="'/Go/' + sponsorName + '/' + portalName + '/' + raiHomeRoute"
               [class.active]="isRouteActive(getRaiRoute(raiHomeRoute))"
               (click)="closeSidebar()">
              <span class="rai-nav-icon"><i class="fa fa-home"></i></span>
              <span class="rai-nav-text">Home</span>
            </a>
          </li>
          <ng-container *ngFor="let item of raiNavItems">
            <li class="rai-nav-item">
              <!-- Parent-only item (e.g. Tools): clicking expands sub-items, no routing -->
              <a class="rai-nav-link"
                 *ngIf="item.expandOnly"
                 href="javascript:void(0);"
                 (click)="toggleSubmenu(item)">
                <span class="rai-nav-icon"><i class="fa" [ngClass]="item.icon"></i></span>
                <span class="rai-nav-text">{{ item.label }}</span>
                <button type="button" class="rai-nav-chevron"
                        *ngIf="item.children.length > 0"
                        (click)="$event.preventDefault(); $event.stopPropagation(); toggleSubmenu(item)"
                        [attr.aria-label]="item.expanded ? 'Collapse ' + item.label : 'Expand ' + item.label">
                  <i class="fa" [ngClass]="item.expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                </button>
              </a>

              <!-- Regular item routing to its component -->
              <a class="rai-nav-link"
                 *ngIf="!item.expandOnly"
                 [routerLink]="getRaiRoute(item.route)"
                 [class.active]="isRouteActive(getRaiRoute(item.route))"
                 (click)="closeSidebar()"
                 medpt-log-action="View"
                 [attr.medpt-log-message]="'Navigate to ' + item.label + ' page'">
                <span class="rai-nav-icon"><i class="fa" [ngClass]="item.icon"></i></span>
                <span class="rai-nav-text">{{ item.label }}</span>
                <button type="button" class="rai-nav-chevron"
                        *ngIf="item.children.length > 0"
                        (click)="$event.preventDefault(); $event.stopPropagation(); toggleSubmenu(item)"
                        [attr.aria-label]="item.expanded ? 'Collapse ' + item.label : 'Expand ' + item.label">
                  <i class="fa" [ngClass]="item.expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                </button>
              </a>

              <ul class="rai-subnav" *ngIf="item.children.length > 0 && item.expanded">
                <li *ngFor="let child of item.children">
                  <a class="rai-subnav-link"
                     [routerLink]="getRaiRoute(child.route)"
                     [class.active]="isRouteActive(getRaiRoute(child.route))"
                     (click)="closeSidebar()"
                     medpt-log-action="View"
                     [attr.medpt-log-message]="'Navigate to ' + child.label + ' page'">
                    {{ child.label }}
                  </a>
                </li>
              </ul>
            </li>
          </ng-container>
        </ul>

        <!-- Mobile-only links: help, account, logout -->
        <div class="rai-nav-divider"></div>
        <ul class="rai-nav-list">
          <li class="rai-nav-item">
            <a class="rai-nav-link" href="javascript:void(0);" [routerLink]="['./Help']" (click)="closeSidebar()">
              <span class="rai-nav-icon"><i class="fa fa-life-ring"></i></span>
              <span class="rai-nav-text">Help</span>
            </a>
          </li>
          <li class="rai-nav-item">
            <a class="rai-nav-link" href="javascript:void(0);" [routerLink]="['./Contact']" (click)="closeSidebar()">
              <span class="rai-nav-icon"><i class="fa fa-envelope-o"></i></span>
              <span class="rai-nav-text">Contact</span>
            </a>
          </li>
          <li class="rai-nav-item">
            <a class="rai-nav-link" href="{{myAppUrl}}/Account/Manage/ChangePassword" (click)="closeSidebar()">
              <span class="rai-nav-icon"><i class="fa fa-key"></i></span>
              <span class="rai-nav-text">Change password</span>
            </a>
          </li>
          <li class="rai-nav-item">
            <a class="rai-nav-link" routerLink="/Account/MyAccount" (click)="closeSidebar()" medpt-log-action="View" medpt-log-message="Navigate to My account page">
              <span class="rai-nav-icon"><i class="fa fa-id-card-o"></i></span>
              <span class="rai-nav-text">My account</span>
            </a>
          </li>
          <li class="rai-nav-item">
            <a class="rai-nav-link" href="{{secureAppUrl}}/Account/Manage/Passkeys" (click)="closeSidebar()">
              <span class="rai-nav-icon"><i class="fa fa-shield"></i></span>
              <span class="rai-nav-text">Manage Passkeys</span>
            </a>
          </li>
          <li class="rai-nav-item">
            <a class="rai-nav-link" href="javascript:void(0);" (click)="logout(); closeSidebar()">
              <span class="rai-nav-icon"><i class="fa fa-sign-out"></i></span>
              <span class="rai-nav-text">Logout</span>
            </a>
          </li>
        </ul>
      </nav>
    </aside>

    <!-- Main content area (projected via ng-content) -->
    <main class="rai-main-content"
          [ngClass]="{
            'rai-main--sidebar-collapsed': isSidebarCollapsed && !isMobileMode,
            'rai-main--ai-panel-open': isAiPanelOpen && !isMobileMode,
            'rai-main--no-sidebar': isDashboard
          }">
      <ng-content></ng-content>
    </main>

    <!-- AI Assistant Panel (docked right on desktop, full-screen drawer on mobile) -->
    <aside class="rai-ai-panel"  *ngIf="isAIEnabled" [ngClass]="{'rai-ai-panel--open': isAiPanelOpen}">
      <div class="rai-ai-panel-header">
        <div class="banner-left">
          <span class="banner-text">RASPberry AI Answers</span>
        </div>
        <div class="chat-controls">
          <a class="icon-close" (click)="closeAiPanel()" title="Close"></a>
        </div>
      </div>
      <div class="rai-ai-panel-body">
        <medpt-raspberry-ai></medpt-raspberry-ai>
      </div>
    </aside>
  </div>
</div>
